import { useCustomCreateDailyFormVehiclePartMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormVehiclePart() {
  const [mutation, { loading, data, error }] = useCustomCreateDailyFormVehiclePartMutation();

  const [createDailyFormVehiclePart, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormVehiclePart",
    },
    { hideMessage: true }
  );

  return [createDailyFormVehiclePart, context] as const;
}
